export default {"src":"/_next/static/media/event-title.53c5d45b.svg","height":29,"width":141};